import { CrownCapNames } from '../CrownCapNames';
import { ShaderAccessorFactory } from './ShaderAccessorFactory';
import { CrownShapeCapUtil } from './CrownShapeCapUtil';
import { ScanPoints } from './ScanPoints';
import { BufferAttribute, BufferGeometry, Group } from 'three';
/**
 * Display and colorize scandata from crown api
 */
export class CrownScanCap {
    constructor() {
        this._shaderAccessorFactory = new ShaderAccessorFactory();
    }
    getName() {
        return CrownCapNames.CROWNSCAN;
    }
    doClassToCapabilityMapping(map) {
        map.set(CrownScanCap.className, CrownCapNames.CROWNSCAN);
        map.set(CrownScanCap.decoClassName, CrownCapNames.CROWNSCAN);
    }
    call(objectIn, sceneIn) {
        const { payload } = objectIn;
        if (payload.Type === CrownScanCap.className) {
            const decoration = !!payload.Decorations && payload.Decorations.length === 1 ? payload.Decorations[0].data : undefined;
            payload.Iconics.forEach((s) => {
                const ps = s.data;
                const thetaView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(ps.ChannelTheta.data, ps.ChannelTheta.endian);
                const geometries = new Array();
                const scanGroup = new Group();
                scanGroup.name = objectIn.name;
                scanGroup.userData.disposer = () => {
                    geometries.forEach((geometry) => {
                        geometry.dispose();
                        geometry = null;
                    });
                    geometries.splice(0, geometries.length);
                };
                ps.DistValues.forEach((distValue, echoIdx) => {
                    const geometry = new BufferGeometry();
                    const distView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(ps.DistValues[echoIdx].data, ps.DistValues[echoIdx].endian);
                    const phiChannel = CrownShapeCapUtil.getPhiFloat32Array(ps.ChannelPhi, ps.DistValues[echoIdx].numOfElems);
                    // three js requires the position attribute with a correct length
                    // the values inside this array aren't used at all, but without this line nothing is getting displayed
                    geometry.addAttribute('position', new BufferAttribute(new Float32Array(distValue.numOfElems * 3), 3));
                    geometry.addAttribute('theta', new BufferAttribute(new Float32Array(thetaView.buffer, thetaView.byteOffset, thetaView.byteLength / 4), 1));
                    geometry.addAttribute('phi', new BufferAttribute(phiChannel, 1));
                    geometry.addAttribute('dist', new BufferAttribute(new Float32Array(distView.buffer, distView.byteOffset, distView.byteLength / 4), 1));
                    const shaderAccessor = this._shaderAccessorFactory.get(ps, decoration, echoIdx);
                    shaderAccessor.updateShader(geometry, decoration);
                    const mesh = new ScanPoints(geometry, shaderAccessor);
                    mesh.frustumCulled = false;
                    scanGroup.add(mesh);
                    geometries.push(geometry);
                });
                sceneIn.addToParent(objectIn.parent || '', scanGroup);
                sceneIn.setTag(objectIn.tag, scanGroup);
            });
            return true;
        }
        return false;
    }
    update(objectIn, sceneIn) {
        const { payload: { Decoration, IconicId } } = objectIn;
        if (Decoration.class === CrownScanCap.decoClassName) {
            const scan = sceneIn.getObjectByName(IconicId);
            if (scan != null) {
                scan.children.forEach(c => {
                    c.updateDecoration(Decoration.data);
                });
                return true;
            }
        }
        return false;
    }
}
CrownScanCap.className = 'POLAR_SCAN';
CrownScanCap.decoClassName = 'View.ScanDecoration';
//# sourceMappingURL=CrownScanCap.js.map